import PropTypes from 'prop-types';
import React, { Component } from "react";
import classnames from "classnames"
import fuzzysearch from "fuzzysearch"
import { injectIntl } from "react-intl"
import { isKeyClick } from "../../scripts/utils"
import Icon from "../elements/Icon"
import messages from "../../messages/search"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class TypeSelect extends Component {
  static defaultProps = {
    value: "",
    options: []
  }

  state = {
    show: false
  }

  static propTypes = {
    handleChange: PropTypes.func,
    handleSelected: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.string,
    placeholder: PropTypes.string
  }

  filterOptions = options => {
    const { value } = this.props
    return value
      ? options.filter(option =>
          fuzzysearch(value.toLowerCase(), option.value.toLowerCase())
        )
      : options
  }

  handleKeyDown = (e, options) => {
    const { value, handleSelected } = this.props

    if (e.keyCode !== 13) return

    if (options.length > 0) {
      handleSelected(options[0].value)
    }

    if (value) {
      handleSelected(value)
    }
  }

  render() {
    const {
      value,
      placeholder,
      options: allOptions,
      handleChange,
      handleSelected,
      intl,
      ...props
    } = this.props
    const { show } = this.state

    const hide = value.length === 0 && !show
    const options = this.filterOptions(allOptions)
    const title = intl.formatMessage(messages.addTermPhrase)

    return (
      <div className="c-typeselect" data-is-dirty={!hide}
           style={getStyles('c-typeselect')}>
        {getStyleTag(['c-typeselect', 'c-typeselect__option'])}
        <div className="input-group mbn"
             style={getStyles('c-typeselect__input-group')}>
          <input
            className="c-typeselect__input input-group-field"
            value={value}
            onChange={handleChange}
            onFocus={e => this.setState({ show: true })}
            onBlur={e => setTimeout(() => this.setState({ show: false }), 800)}
            onKeyDown={e => this.handleKeyDown(e, options)}
            placeholder={placeholder}
            type="text"
            {...props}
          />
          <div className="c-typeselect__button-holder input-group-button"
               style={getStyles('c-typeselect__button-holder')}>
            <button
              type="button"
              className="c-typeselect__button c-search__button--add button"
              style={getStyles(['c-typeselect__button', 'input-group-button__button'])}
              title={title}
              aria-label={title}
              onClick={e => {
                if (value.length > 0) handleSelected(value)
              }}
            >
              <Icon icon="plus" style={getStyles('c-typeselect__icon')} />
            </button>
          </div>
        </div>
        <ul className={classnames("c-typeselect__list ", { hide: hide })}
            style={getStyles('c-typeselect__list')}>
          {options.map((option, i) => (
            <li
              className="c-typeselect__option"
              key={option.value}
              onClick={e => handleSelected(option.value)}
              onKeyPress={e => {
                if (isKeyClick(e)) handleSelected(option.value)
              }}
              tabIndex="0"
            >
              {option.label} <small>({option.count})</small>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
export default injectIntl(TypeSelect)



// WEBPACK FOOTER //
// ./webapp/components/elements/TypeSelect.js